var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.17969L15.6797 2H2.32031L9 6.17969ZM15.6797 12V3.67969L9 7.82031L2.32031 3.67969V12H15.6797ZM15.6797 0.320312C16.1224 0.320312 16.5 0.489583 16.8125 0.828125C17.151 1.16667 17.3203 1.55729 17.3203 2V12C17.3203 12.4427 17.151 12.8333 16.8125 13.1719C16.5 13.5104 16.1224 13.6797 15.6797 13.6797H2.32031C1.8776 13.6797 1.48698 13.5104 1.14844 13.1719C0.835938 12.8333 0.679688 12.4427 0.679688 12V2C0.679688 1.55729 0.835938 1.16667 1.14844 0.828125C1.48698 0.489583 1.8776 0.320312 2.32031 0.320312H15.6797Z",
    fill: "#105099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.350d71975095802081ecaa04f0c76329.svg";
export { ForwardRef as ReactComponent };